import { AttemptDataType } from "./intial-data";

import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getCountryAddress = async (creData) => {
  const { ipAddress } = creData;
  return secureGet("/api/user/geo", { ipAddress });
};

export const getSurveyData = async (cred) => {
  const { userId, page, userLangCode, sortColumnName, sortColumnOrder, country, ipAddress, userType } = cred;
  return secureGet("/api/user/geos", { userId, page, userLangCode, sortColumnName, sortColumnOrder, country, ipAddress, userType });
};

export const getRedeemRequestHistoryData = async (panelistId: number, page: number) => {
  return secureGet("/api/survey/getZampliaSurveysClaimRequest", { panelistId, page, requestType: "Virtual Wallet", panel: "ZampliaSurveys" });
};

export const addParticipant = async (obj: AttemptDataType) => {
  return securePost("/api/user/add_user", { obj });
};